import type { EditorValue } from '@octopus-do/octopus-editor'
import type { WithId } from '@octopus-do/octopus-project-core'
import { migrationUiSelector } from '@store/migrationSelectors/uiSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useArtBoardDisabled } from '@/hooks/selectors/useArtBoardDisabled'
import type { StorageItem } from '../../types'
import { PureBlockEditor } from '../PureBlockEditor'
import { useBlockFocus, useSymbolContent, useUpdateContent } from './hooks'

interface Props extends WithId {
  onUpload: (files: FileList) => Promise<StorageItem[]>

  readonly: boolean
}

export const SymbolEditor: React.FC<Props> = ({ id, onUpload, readonly }) => {
  const { onFocus, onBlur } = useBlockFocus()
  const { onChange, onRename } = useUpdateContent(id)
  const { color, content, title } = useSymbolContent(id)

  const locked = useSelector(migrationUiSelector.getLocks(id))

  // The artboard is off and nothing typed here would be saved: the editor
  // closes with it instead of taking text that is gone on the next load.
  const artboardDisabled = useArtBoardDisabled()

  return (
    <PureBlockEditor
      key={id}
      onFocus={onFocus}
      onBlur={onBlur}
      color={color}
      onChange={onChange}
      onUpload={onUpload}
      onRename={onRename}
      content={content as unknown as EditorValue}
      title={title}
      readonly={readonly || artboardDisabled}
      locked={Boolean(locked)}
    />
  )
}
